/**
 * MSW Overrides: Booking Available Ancillaries scenario
 *
 * Returns a mocked response for GET /subscriptions/:subscriptionId/bookings/ancillaries
 * while the real endpoint is not yet available, allowing the ancillaries selection
 * flow to be tested end-to-end in local development.
 *
 * Enable by setting ENABLE_MSW=true and NUXT_PUBLIC_MSW_OVERRIDES_BOOKING_ANCILLARIES=true
 * in your .env, then restart the dev server.
 */

import { http, HttpResponse } from 'msw';
import { BFF_ENDPOINTS, toMSWPattern } from '@cvo/domain';
import type { BookingAvailableAncillariesResponse } from '@cvo/domain';

export const MOCK_BOOKING_AVAILABLE_ANCILLARIES: BookingAvailableAncillariesResponse = {
  ancillaries: [
    {
      person_id: '11111111-1111-1111-1111-111111111111',
      outbound: [
        {
          code: 'CB_23',
          type: 'BAGGAGE',
          details: { weight: 23, units: 'kg', amount: 1, descriptionKey: 'ancillary.checked_baggage' },
          max_units: 1,
          price: { amount: '0.00', currency: 'EUR' },
        },
        {
          code: 'CABINBAG',
          type: 'BAGGAGE',
          details: { weight: 10, units: 'kg', amount: 1, descriptionKey: 'ancillary.cabin_bag' },
          max_units: 1,
          price: { amount: '0.00', currency: 'EUR' },
        },
        {
          code: 'CARRY_10',
          type: 'BAGGAGE',
          details: { weight: 10, units: 'kg', amount: 1, descriptionKey: 'ancillary.carry_on' },
          max_units: 1,
          price: { amount: '29.00', currency: 'EUR' },
        },
      ],
      inbound: [
        {
          code: 'CB_23',
          type: 'BAGGAGE',
          details: { weight: 23, units: 'kg', amount: 1, descriptionKey: 'ancillary.checked_baggage' },
          max_units: 1,
          price: { amount: '0.00', currency: 'EUR' },
        },
        {
          code: 'CABINBAG',
          type: 'BAGGAGE',
          details: { weight: 10, units: 'kg', amount: 1, descriptionKey: 'ancillary.cabin_bag' },
          max_units: 1,
          price: { amount: '0.00', currency: 'EUR' },
        },
        {
          code: 'CARRY_10',
          type: 'BAGGAGE',
          details: { weight: 10, units: 'kg', amount: 1, descriptionKey: 'ancillary.carry_on' },
          max_units: 1,
          price: { amount: '29.00', currency: 'EUR' },
        },
      ],
    },
  ],
} as unknown as BookingAvailableAncillariesResponse;

export function createBookingAncillariesOverrides(baseUrl: string) {
  const sanitizedBaseUrl = baseUrl.replace(/\/$/, '');

  return [
    http.get(
      `${sanitizedBaseUrl}/${toMSWPattern(BFF_ENDPOINTS.BOOKING_ANCILLARIES)}`,
      () => HttpResponse.json(MOCK_BOOKING_AVAILABLE_ANCILLARIES),
    ),
  ];
}
